import React from 'react';
import miniHandlebars from '@tmap/mmm-core/miniHandlebars';
import locationLabelText from '@tmap/mmm-core/locationLabelText';

import client from '../../../client';
import FullWrapper from '../../../layouts/fullWrapper';
import requireUser from '../../../lib/requireUser';
import {
  getContributionBySlug,
} from '../../../actions/contributions';

import Metatags from '../../../components/metatags';
import PostForm from '../../../components/communityContent/submitPage/postForm';

function CreatePostPage(props) {
  const {
    community,
    existingPost = {},
    postSettings = {},
  } = props;

  const isEditing = Object.entries(existingPost)?.length > 0;

  const pageTitleTemplate = isEditing ? (postSettings?.postTitleUpdate ?? 'Update Your Post for {{locationLabel}}')
    : (postSettings?.postTitleNew ?? 'Submit a New Post for {{locationLabel}}');
  const pageTitle = miniHandlebars(
    pageTitleTemplate,
    { locationLabel: locationLabelText(community.locationText, community.regionText) },
  );

  const canonicalUrl = `${process.env.NEXT_PUBLIC_CANONICAL_DOMAIN}/moving-living/${community.slug.current}/post`;

  return (
    <>
      <Metatags
        title={pageTitle}
        description=''
        canonical={canonicalUrl}
      />
      <FullWrapper>
        <PostForm
          isEditing={isEditing}
          community={community}
          existingPost={existingPost}
          postSettings={postSettings}
          pageTitle={pageTitle}
        />
      </FullWrapper>
    </>
  );
}

export const getServerSideProps = async (context) => {
  const { slug = '', postId, type = 'default' } = context.query;

  const existingPost = postId ? (await getContributionBySlug(postId))?.data || {}
    : {};

  const { community, postSettings } = await client.fetch(`{
    'community': *[_type == 'community' && slug.current == $slug][0],
    'postSettings': *[_type == 'ugcTypes' && type == $type][0]
  }`, { slug, type });
  if (!community || !postSettings) {
    return { notFound: true };
  }
  return {
    props: {
      community,
      existingPost,
      postSettings: postSettings || {},
    },
  };
};

export default requireUser(CreatePostPage);
